
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iDxDj", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $3lWl0 = parcelRequire("3lWl0");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $3jwuS = parcelRequire("3jwuS");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");



var $qP1yw = parcelRequire("qP1yw");


var $bJX6u = parcelRequire("bJX6u");

const $f084987bc41bc5d5$var$EditorContentStateDataGetter = (t0)=>{
    const $ = (0, $frIzR.c)(36);
    const { contentId: contentId, contentType: contentType, contentStateState: contentStateState, isPublishingContent: isPublishingContent, userOffline: userOffline, onContentStateMenuToggle: onContentStateMenuToggle, floatingToolbarButtonStyle: floatingToolbarButtonStyle, renderPlusButtonEmptyState: renderPlusButtonEmptyState, isDetailsPanel: isDetailsPanel, onClick: onClick } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    const t1 = !isCurrentPageLive;
    let t2;
    if ($[0] !== isCurrentPageLive) {
        t2 = (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? false : !isCurrentPageLive;
        $[0] = isCurrentPageLive;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== contentId || $[4] !== t1 || $[5] !== t2) {
        t4 = {
            contentId: contentId,
            isDraft: t1,
            shouldSkipContentStateLastUpdated: t2,
            isApprovalsFgOn: t3,
            format: (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? "MILLIS" : "USER_FRIENDLY"
        };
        $[3] = contentId;
        $[4] = t1;
        $[5] = t2;
        $[6] = t4;
    } else t4 = $[6];
    const t5 = t4;
    const t6 = !contentStateState.state.shouldRunContentStateEffect;
    let t7;
    if ($[7] !== t5 || $[8] !== t6) {
        t7 = {
            fetchPolicy: Boolean(window.__SSR_RENDERED__) ? "cache-first" : "network-only",
            variables: t5,
            skip: t6
        };
        $[7] = t5;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $3lWl0.default), t7);
    data?.availableContentStates?.spaceContentStates;
    let t8;
    if ($[10] !== data?.availableContentStates?.spaceContentStates) {
        t8 = data?.availableContentStates?.spaceContentStates?.filter($f084987bc41bc5d5$var$_temp) || [];
        $[10] = data?.availableContentStates?.spaceContentStates;
        $[11] = t8;
    } else t8 = $[11];
    const defaultStatesArray = t8;
    let t9;
    if ($[12] !== data?.availableContentStates?.customContentStates) {
        t9 = ()=>data?.availableContentStates?.customContentStates?.filter($f084987bc41bc5d5$var$_temp2) || [];
        $[12] = data?.availableContentStates?.customContentStates;
        $[13] = t9;
    } else t9 = $[13];
    data?.availableContentStates?.customContentStates;
    let t10;
    if ($[14] !== t9) {
        t10 = t9();
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    const customStatesArray = t10;
    const prevContentIdRef = (0, $42omo.useRef)(contentId);
    let t11;
    let t12;
    if ($[16] !== contentId || $[17] !== contentStateState) {
        t11 = ()=>{
            if (prevContentIdRef.current !== contentId && (0, $9wGTI.fg)("confluence_frontend_transition_preloading_system")) {
                prevContentIdRef.current = contentId;
                contentStateState?.resetToDefaults();
            }
        };
        t12 = [
            contentId,
            contentStateState
        ];
        $[16] = contentId;
        $[17] = contentStateState;
        $[18] = t11;
        $[19] = t12;
    } else {
        t11 = $[18];
        t12 = $[19];
    }
    (0, $42omo.useEffect)(t11, t12);
    let t13;
    let t14;
    if ($[20] !== contentStateState || $[21] !== customStatesArray || $[22] !== data || $[23] !== defaultStatesArray) {
        t13 = ()=>{
            if (data && contentStateState.state.shouldRunContentStateEffect) {
                const newContentStateValues = Object.assign({}, (0, $bJX6u.defaultValues));
                newContentStateValues.shouldRunContentStateEffect = false;
                newContentStateValues.contentState = data?.singleContent?.contentState || null;
                newContentStateValues.contentStateLastUpdated = data?.singleContent?.contentStateLastUpdated?.value || null;
                newContentStateValues.defaultStatesArray = defaultStatesArray;
                newContentStateValues.customStatesArray = customStatesArray;
                const isSuggestedContentStatesDisabled = !data?.availableContentStates?.spaceContentStates;
                const isCustomContentStatesDisabled = !data?.availableContentStates?.customContentStates;
                const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
                if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
                else {
                    if (isSuggestedContentStatesDisabled) newContentStateValues.isSuggestedEnabled = false;
                    else if (isCustomContentStatesDisabled) newContentStateValues.isCustomEnabled = false;
                }
                contentStateState.setInitialValues(newContentStateValues);
            }
        };
        t14 = [
            data,
            contentStateState,
            defaultStatesArray,
            customStatesArray
        ];
        $[20] = contentStateState;
        $[21] = customStatesArray;
        $[22] = data;
        $[23] = defaultStatesArray;
        $[24] = t13;
        $[25] = t14;
    } else {
        t13 = $[24];
        t14 = $[25];
    }
    (0, $42omo.useEffect)(t13, t14);
    if (isPublishingContent) createAnalyticsEvent({
        type: "sendTrackEvent",
        data: {
            action: "publishedWithContentState",
            actionSubject: "page",
            objectId: contentId,
            source: "editorContentState"
        }
    }).fire();
    let t15;
    if ($[26] !== contentId || $[27] !== contentStateState || $[28] !== contentType || $[29] !== floatingToolbarButtonStyle || $[30] !== isDetailsPanel || $[31] !== onClick || $[32] !== onContentStateMenuToggle || $[33] !== renderPlusButtonEmptyState || $[34] !== userOffline) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $qP1yw.LazyEditorContentStateComponent), {
            contentId: contentId,
            contentType: contentType,
            contentStateState: contentStateState,
            userOffline: userOffline,
            onContentStateMenuToggle: onContentStateMenuToggle,
            floatingToolbarButtonStyle: floatingToolbarButtonStyle,
            renderPlusButtonEmptyState: renderPlusButtonEmptyState,
            isDetailsPanel: isDetailsPanel,
            onClick: onClick
        });
        $[26] = contentId;
        $[27] = contentStateState;
        $[28] = contentType;
        $[29] = floatingToolbarButtonStyle;
        $[30] = isDetailsPanel;
        $[31] = onClick;
        $[32] = onContentStateMenuToggle;
        $[33] = renderPlusButtonEmptyState;
        $[34] = userOffline;
        $[35] = t15;
    } else t15 = $[35];
    return t15;
};
const $f084987bc41bc5d5$var$EditorContentStateWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($f084987bc41bc5d5$var$EditorContentStateDataGetter);
const $f084987bc41bc5d5$var$contentStateContainers = [
    (0, $bJX6u.ContentStateStateContainer)
];
const $f084987bc41bc5d5$export$2791e79b1a186ba4 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: $f084987bc41bc5d5$var$contentStateContainers
        }, (contentStateState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f084987bc41bc5d5$var$EditorContentStateWithErrorBoundary, {
                ...props,
                contentStateState: contentStateState
            }));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
function $f084987bc41bc5d5$var$_temp(i) {
    return !!i;
}
function $f084987bc41bc5d5$var$_temp2(i_0) {
    return !!i_0;
}
module.exports["EditorContentState"] = $f084987bc41bc5d5$export$2791e79b1a186ba4;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<563a8c271f26df74e9f3c31c7adc5db3>>
 * @relayHash b4c5e8d8fe0e4cf7e15ddede8b214601
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50c0ce974af8bdc413c3f60e4d9e3ba911ae7557d0935f2f44379c4bc9411469
const $34dd87dd4e33f987$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isApprovalsFgOn"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkipContentStateLastUpdated"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "ScalarField",
        "name": "color"
    }, v9 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v10 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                {
                    "args": [
                        v6 /*: any*/ 
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCallerPermitted"
                        },
                        {
                            "condition": "isApprovalsFgOn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifierAaid"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldSkipContentStateLastUpdated",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "format",
                                    "variableName": "format"
                                },
                                v6 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "AvailableContentStates",
            "kind": "LinkedField",
            "name": "availableContentStates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "customContentStates",
                    "plural": true,
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "spaceContentStates",
                    "plural": true,
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v5 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v10 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v10 /*: any*/ 
        },
        "params": {
            "cacheID": "b4c5e8d8fe0e4cf7e15ddede8b214601",
            "id": "50c0ce974af8bdc413c3f60e4d9e3ba911ae7557d0935f2f44379c4bc9411469",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted,lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "2ad6563c393bf2c4924f755b12809ec0";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("qP1yw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $dzxx6 = parcelRequire("dzxx6");


const $d4d6077acc6972b1$export$a5601a59fc831df9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qET7f",
    name: "LazyEditorContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("6Z0Fh"))).EditorContentStateComponent;
    }
});

const $d4d6077acc6972b1$export$c49c9d91fa2cc91e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "OYB6O",
    name: "LazyRendererContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("9EUwJ"))).RendererContentStateComponent;
    },
    loading: (0, $dzxx6.RendererContentStatePlaceholder)
});
module.exports["LazyEditorContentStateComponent"] = $d4d6077acc6972b1$export$a5601a59fc831df9;
module.exports["LazyRendererContentStateComponent"] = $d4d6077acc6972b1$export$c49c9d91fa2cc91e;

});

parcelRegister("dzxx6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $3jwuS = parcelRequire("3jwuS");


var $9wGTI = parcelRequire("9wGTI");

const $62a49c8d20755563$var$loadingPlaceholderBaseStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    minHeight: '32px',
    borderRadius: 'radius.small',
    paddingRight: 'space.100'
});
const $62a49c8d20755563$var$placeHolderBackroundColorStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral'
});
const $62a49c8d20755563$var$subtlePlaceholderBackgroundColorStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'utility.elevation.surface.current'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62a49c8d20755563$var$ContentStateNamePlaceholderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_k48p1wq8 _3um015vq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $62a49c8d20755563$var$classicContentStateColorPlaceholderStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.xlarge',
    height: '12px',
    width: '12px',
    marginTop: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral'
});
const $62a49c8d20755563$var$subtleContentStateColorPlaceholderStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full',
    height: '10px',
    width: '10px',
    marginLeft: 'space.050',
    marginRight: 'space.075',
    backgroundColor: 'color.background.neutral'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62a49c8d20755563$var$StyledBorder = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s81b3y _1kl71qn1 _1e0c1o8l _1bsbt94y _4t3i7vkz _1wpz1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $62a49c8d20755563$var$flexWrapperStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.075',
    marginRight: 'space.075'
});
const $62a49c8d20755563$export$6679211e6c7373d = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { contentState: contentState, isDraft: isDraft } = t0;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const t1 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? $62a49c8d20755563$var$subtlePlaceholderBackgroundColorStyles : $62a49c8d20755563$var$placeHolderBackroundColorStyles;
    let t2;
    if ($[0] !== t1) {
        t2 = [
            $62a49c8d20755563$var$loadingPlaceholderBaseStyles,
            t1
        ];
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const contentStateLoadingPlaceholderStyles = t2;
    const t3 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? $62a49c8d20755563$var$subtleContentStateColorPlaceholderStyles : $62a49c8d20755563$var$classicContentStateColorPlaceholderStyles;
    let t4;
    if ($[2] !== t3) {
        t4 = [
            t3
        ];
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const contentStateColorPlaceholderStyles = t4;
    const t5 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? "subtle-renderer-content-state-placeholder" : "renderer-content-state-placeholder";
    const t6 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? "subtle-renderer-content-state-color-placeholder" : "renderer-content-state-color-placeholder";
    let t7;
    if ($[4] !== contentStateColorPlaceholderStyles || $[5] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: contentStateColorPlaceholderStyles,
            testId: t6
        });
        $[4] = contentStateColorPlaceholderStyles;
        $[5] = t6;
        $[6] = t7;
    } else t7 = $[6];
    const t8 = contentState?.name;
    let t9;
    if ($[7] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($62a49c8d20755563$var$ContentStateNamePlaceholderWrapper, null, t8);
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== contentStateLoadingPlaceholderStyles || $[10] !== t5 || $[11] !== t7 || $[12] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            as: "li",
            alignItems: "center",
            xcss: contentStateLoadingPlaceholderStyles,
            testId: t5
        }, t7, t9);
        $[9] = contentStateLoadingPlaceholderStyles;
        $[10] = t5;
        $[11] = t7;
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== isDraft) {
        t11 = !isDraft && !(0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($62a49c8d20755563$var$StyledBorder, {
            "data-testid": "placeholder-vertical-line"
        });
        $[14] = isDraft;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t10 || $[17] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $62a49c8d20755563$var$flexWrapperStyles
        }, t10, t11);
        $[16] = t10;
        $[17] = t11;
        $[18] = t12;
    } else t12 = $[18];
    return t12;
};
module.exports["RendererContentStatePlaceholder"] = $62a49c8d20755563$export$6679211e6c7373d;

});

parcelRegister("6Z0Fh", function(module, exports) {

let $5158f49925f41b61$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5158f49925f41b61$var$load("av6T2"),
    $5158f49925f41b61$var$load("d5xSh"),
    $5158f49925f41b61$var$load("hHy5c"),
    $5158f49925f41b61$var$load("er7wn"),
    $5158f49925f41b61$var$load("6wr18"),
    $5158f49925f41b61$var$load("3dFwk"),
    $5158f49925f41b61$var$load("fufpJ"),
    $5158f49925f41b61$var$load("h4Nf7"),
    $5158f49925f41b61$var$load("lu4e5"),
    $5158f49925f41b61$var$load("fuKGN"),
    $5158f49925f41b61$var$load("4IYLb"),
    $5158f49925f41b61$var$load("Wowvf"),
    $5158f49925f41b61$var$load("kHOMt"),
    $5158f49925f41b61$var$load("dRpV3"),
    $5158f49925f41b61$var$load("ffEVr"),
    $5158f49925f41b61$var$load("7EorR"),
    $5158f49925f41b61$var$load("dTsOE"),
    $5158f49925f41b61$var$load("hhss7"),
    $5158f49925f41b61$var$load("4UuEP"),
    $5158f49925f41b61$var$load("9DDT5")
]).then(()=>parcelRequire('2TweP'));

});

parcelRegister("9EUwJ", function(module, exports) {

let $7083b28f0e74da40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7083b28f0e74da40$var$load("jcEo4").then(()=>parcelRequire('llcSD'));

});


//# sourceMappingURL=EditorContentState.45f63c08.js.map
